import { AlpineJobDescription, pParseAlpineMetaFiles } from './connections/alpineConnections';
import { ParsedJobMetaData, pGetMiTekJobMetaData } from './connections/sealingServiceConnections';
import { UploadedFile } from './files/UploadedFile';
import { JobMetaData } from './types';
import { findFileByExtension, isMiTekJob } from './utilities/jobFileList';

export async function pFetchMetaData(filesInJob: UploadedFile[]): Promise<JobMetaData> {
  let fetchedMetaData: ParsedJobMetaData;

  if (isMiTekJob(filesInJob)) {
    fetchedMetaData = await pFetchMiTekJobMetaData(filesInJob);
  } else {
    fetchedMetaData = await pFetchAlpineJobMetaData(filesInJob);
  }

  for (const key of Object.keys(fetchedMetaData)) {
    if (fetchedMetaData[key as keyof ParsedJobMetaData] == null) {
      delete fetchedMetaData[key as keyof ParsedJobMetaData];
    }
  }

  return fetchedMetaData as JobMetaData;
}

async function pFetchMiTekJobMetaData(files: UploadedFile[]): Promise<ParsedJobMetaData> {
  const ansEntry = findFileByExtension(files, 'ans');
  const treEntry = findFileByExtension(files, 'tre');

  if (ansEntry == null || treEntry == null) {
    return {};
  }

  const treContents = await treEntry.getContents();
  const ansContents = await ansEntry.getContents();

  try {
    return pGetMiTekJobMetaData(treContents, ansContents);
  } catch {
    console.error('Failed to parse MiTek job metadata.');
    return {};
  }
}

async function pFetchAlpineJobMetaData(files: UploadedFile[]): Promise<ParsedJobMetaData> {
  const ofEntry = findFileByExtension(files, 'of');
  if (ofEntry == null) {
    return {};
  }

  let serverData: AlpineJobDescription;
  try {
    serverData = await pParseAlpineMetaFiles(ofEntry);
  } catch {
    console.error('Failed to parse Alpine job metadata.');
    return {};
  }

  return {
    name: serverData['jobName'],
    designProgram: `Alpine ${serverData['designProgram']}`,
    designCode: serverData['designCode'],

    roofLoad:
      `${serverData['ofValues']['topChordLiveLoad']} - ${serverData['ofValues']['topChordDeadLoad']} - ` +
      `${serverData['ofValues']['bottomChordLiveLoad']} - ${serverData['ofValues']['bottomChordDeadLoad']}`,
    windCode: serverData['ofValues']['windLoading'],

    lotNumber: serverData['ofValues']['jobKey'],
  };
}
